


































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import EventHero from '@ui/Event/EventHero'

settings =
  name: 'EventShow'
  components: { LoadingIndicator, EventHero }

  resources:
    event:
      resourceName: 'event'
      slug: 'events/:eventId'

    campaigns:
      resourceName: 'campaign'
      slug: 'campaigns'

  vue:
    computed:
      isLoading: -> !@event || !@campaigns || @campaigns?.length is 1
      hostName: -> @ctxHost(@event).name

    methods:
      hiNavigateToCampaignWizard: -> @$router.push({ name: 'CampaignCreatePage' })

      navigateToCampaignEvent: (campaign) ->
        @$router.replace({ name: 'CampaignEventFeedEventShow', params: { campaignId: campaign.id, eventId: @event.id } })

    watch:
      campaigns: ->
        return if !@campaigns || !@event
        @navigateToCampaignEvent(@campaigns[0]) if @campaigns.length is 1

export default VueOptions.vue settings
